import { BUTTON_HEIGHT_32 } from '../../../../../../Button'
import { FieldStackedLabel } from '../../../../../../Field'
import {
  FormBody,
  FormFieldsContainer,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../../../../Form'
import {
  RentalPortalListingBuildingField,
  RentalPortalListingFlatField,
} from '../../../../../../RentalPortalListing'
import { useRentalPortalProfileBlockFormActions } from '../../../../../RentalPortal.hooks'

import * as styles from '../../RentalPortalListingProfileWidgetAddress.module.css'

function ListingProfileWidgetAddressFormFields({
  isCloseConfirm,
  notifications,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { actionsProps } = useRentalPortalProfileBlockFormActions({
    buttonHeight: BUTTON_HEIGHT_32,
    isCloseConfirm,
    onCancel,
  })

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  return (
    <FormBody actionsProps={actionsProps} className={styles.formBody}>
      <FormInlineNotifications notifications={notifications} />
      <FormFieldsContainer className={styles.fields}>
        <RentalPortalListingBuildingField
          Field={FieldStackedLabel}
          borderless={false}
        />
        <RentalPortalListingFlatField
          FieldComponent={FieldStackedLabel}
          borderless={false}
        />
      </FormFieldsContainer>
    </FormBody>
  )
}

export default ListingProfileWidgetAddressFormFields
